<template>
  <div class="donation-filters mb-8">
    <div class="flex justify-between bg-grey-1 rounded-md relative">
      <Dropdown
        v-model="values.year"
        placeholder="Yearly"
        data-variable="years"
        @update="formatFilter" />
      <span class="d-block border border-text absolute w-1/100 h-3/4 left-1/2 z-10 top-1.5 bottom-2"></span>
      <Dropdown 
        class="month"
        v-model="values.month"
        placeholder="Month"
        data-variable="months"
        @update="formatFilter"
      />
    </div>
  </div>  
</template>
<script>
import Dropdown from '../UI/Dropdown.vue'
const currentYear = new Date().getFullYear()
const currentMonth = new Date().getMonth() + 1
export default {
  components: {
    Dropdown
  },
  data () {
    return {
      values: {
        year: currentYear,
        month: currentMonth
      }   
    }
  },
  computed: {
    isValidYear () {
      return this.values.year && this.values.year != 'Year'
    }
  },
  methods: {
    formatFilter () {
      let obj = {
        month: this.values.month ,
        year: this.isValidYear && this.values.year
      }
      this.$emit('set-filters', obj)
    }
  }
}
</script>
<style lang="scss">
  
</style>